import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { api, errMessage } from "../lib/api";
import { useAuth } from "../lib/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams((location.hash || "").replace(/^#/, "")).get("session_id");

    const run = async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        localStorage.setItem("pm_token", data.session_token);
        setUser(data.user);
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate(data.user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      } catch (e) {
        toast.error(errMessage(e));
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate("/login", { replace: true });
      }
    };
    run();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center" data-testid="auth-callback">
      <p className="text-sm text-slate-500">Signing you in…</p>
    </div>
  );
}
